import {FunctionComponent} from "react";
import {AllowedColours} from "../../data/colours";
import styles from './ClusterChartLabel.module.css';
import ChartLabelExpanded from "../chart-label-expanded/ChartLabelExpanded";

export interface ClusterChartLabelProps {
    cx: number,
    cy: number,
    val: number,
    oldVal: number,
    color: AllowedColours,
    isLast: boolean,
    width: number,
}

const ClusterChartLabel: FunctionComponent<ClusterChartLabelProps> = ({cx, cy, val, oldVal, color, isLast}) => {

    return (
        <g className={styles["legend-container"]}>
            <g
                style={{isolation: "isolate"}}
                transform={`translate(${cx || 0} ${cy || 0})`}
                className={styles["legend-small"]}
            >
                <g style={{transform: "scaleY(-100%)"}}>
                    <g>
                        <g style={{opacity: 0.9}}>
                            <image style={{opacity: 0.15, mixBlendMode: "multiply"}}
                                   width="79"
                                   height="56"
                                   xlinkHref="data:image/png;base64,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"
                            />
                            <rect
                                style={{fill: "#fff"}}
                                x="4.69"
                                y="4.91"
                                width="59.68"
                                height="36.81"
                                rx="18.41"
                            />
                            <text
                                style={{
                                    fontSize: "16.24px",
                                    fill: color,
                                    fontFamily: "Poppins, sans-serif",
                                    fontWeight: 600,
                                }}
                                transform="translate(18.02 29.3)"
                            >
                                {val}%
                            </text>
                        </g>
                    </g>
                    <g className={styles.showOnHover}>
                        <ChartLabelExpanded {...{val, oldVal, color, isLast}}/>
                    </g>
                </g>
            </g>
        </g>
    );
};

export default ClusterChartLabel;

